import i18next from 'i18next';
import { platformService } from '../../services/platform.service';
import { InlineEditRefused, RequiredPropertySetting, missingRequiredMessage, missingRequiredProperties, ticketSaveRefusal } from './inlineCell';

/**
 * Asks the server about the ticket before a cell saves to it, and refuses the save if the ticket has since been closed
 * or merged, or while a required custom property has no answer - a list row says what the ticket was when the list
 * loaded, and the server enforces none of this itself. `editingPropertyId` is the custom property the cell saves, if any.
 */
export const ticketSaveGuard = (
  ticketId: number, statusChange: boolean, properties?: RequiredPropertySetting[], editingPropertyId?: string
) => async () => {
  const { data } = await new platformService().getTicket(ticketId, '?$select=Closed,IsMerged,CustomPropertiesAnswerJson');
  const refusal = ticketSaveRefusal(data, statusChange);
  if (refusal) throw new InlineEditRefused(i18next.t(refusal));
  const missing = missingRequiredMessage(missingRequiredProperties(data?.CustomPropertiesAnswerJson, properties, editingPropertyId));
  if (missing) throw new InlineEditRefused(missing);
};
